//Константы из SetupView
export default {
  classes: {
    table: { name: "Таблица", defaultTitle: "Новая таблица" },
    list: { name: "Список", defaultTitle: "Новый список" },
    tree: { name: "Дерево", defaultTitle: "Новое дерево" },
    graph: { name: "Граф", defaultTitle: "Новый граф" },
    multi: { name: "Набор", defaultTitle: "Новый набор" },
    html: { name: "Другие представления", defaultTitle: "Новые материалы" },
    cmp: { name: "Сравнение", defaultTitle: "Новое сравнение" },
    exporter: { name: "Экспортёр", defaultTitle: "Новый экспорт" }
  },

  props: {
    hide_in_list: "Не показывать в общем списке",

    view_title: "Название представления",
    view_description: "Описание представления",

    src_endpoint: "Эндпойнт запроса",
    src_query: "Запрос SPARQL",
    page_size: "Количество возвращаемых записей",

    tree_width: "Ширина дерева, %",

    link_view: "Связанное представление",
    link_col: "Ссылка",

    border: "Рамка",
    border_width: "Толщина рамки, пикс",
    border_color: "Цвет рамки",

    col_field: "Поле данных",
    col_data: "Пример значения",
    col_uri: "Поле с URI",
    col_show: "Отображать поле",
    alpha_col: "Поле для АУ",
    col_title: "Заголовок колонки",
    col_html: "Выводить как HTML",
    col_group: "Группировать по полю",
    col_separator: "Разделитель при объединении",
    col_width: "Ширина колонки",
    col_width_min: "Минимальная ширина колонки",

    col_foreground: "Цвет шрифта",
    col_background: "Цвет фона",
    font_size: "Размер шрифта, пикс",
    font_style: "Начертание шрифта",
    font_weight: "Насыщенность шрифта",
    alignment: "Выравнирование",

    graph: "Имя графа",
    typeAsSuperClass: "Тип определяет родительский класс",
    show_type: "Тип отображения",
    typesFilter: "Список uri, которые будут отображаться узлами",
    linksFilter: "Список uri, которые будут отображаться рёбрами",
    labelsFilter: "Список uri, которые содержат метки",
    createTypes: "Типы, которые надо создавать",
    namespaces: "Cписок пространства имён",
    extra_options: "Строка дополнительных настроек",

    gen_endpoint: "Эндпойнт генератора",
    sparqls_var_name: "Имя переменной",
    sparqls_query: "Тело запроса",
    sparqls_endpoint: "Эндпойнт запроса",
    templates_file_name: "Имя файла",
    templates_content: "Содержимое файла",
    gen_type: "Тип генерации",

    html_code: "Произвольный html код"
  },
  props_extra: {
      tree_width: "Ширина дерева, %",
      src_query_root: "Запрос SPARQL корневых узлов дерева",
      
      graph_name: "Имя графа",
      type_as_superclass: "Тип определяет родительский класс",
      show_type: "Тип отображения",

      graph_types_filter: "Список uri, которые будут отображаться узлами",
      graph_links_filter: "Список uri, которые будут отображаться рёбрами",
      graph_labels_filter: "Список uri, которые содержат метки",
      graph_create_types: "Типы, которые надо создавать",

      namespaces: "Cписок пространства имён",
      extra_options: "Строка дополнительных настроек",

      next_multi_item: "Следующий элемент набора",
      linked_view: "Связанное представление",

      html_code: "Произвольный html код",

      graph_list: "Список графов для сравнения",

      gen_endpoint: "Эндпойнт генератора",
      
      sparqls: "SPARQL запросы с параметрами",
      sparqls_var_name: "Имя переменной",
      sparqls_query: "Тело запроса",
      sparqls_endpoint: "Эндпойнт запроса",

      templates: "Шаблоны с параметрами",
      templates_file_name: "Имя файла",
      templates_content: "Содержимое файла",

      gen_type: "Тип генерации",
      
      src_query_children: "Запрос SPARQL дочерних узлов дерева",
      uri: "URI",
      background_color: "Цвет фона"
  },
  comments: {
    src_query_root: "Запрос должен возвращать как минимум ?URI",
    src_query_cmp: "Укажите в запросе %CMP_FROM% - что сравнить, %CMP_TO% - с чем сравнить.",
    src_query_children: "Запрос должен возвращать как минимум ?URI и ?PARENT_URI. Для подстановки id родительского узла используйте ?PARENT_URI",
    page_size: "Используется для постраничного просмотра. 0 - возвращаются все записи.",
    namespaces: "Cписок пространства имён",
    extra_options: "Строка дополнительных настроек",
    html_code: "Произвольный html код"
  },
  common: {
    hidden_suffix: " (не показывать)"
  },
  common_extra: {
      subtree: "Следующий уровень дерева",
      columns: "Отображение данных",
      border: "Рамка",
      no_value: "нет"
  },
  defaults: {
    untitled_view: "Без названия"
  }
}
